import { Link } from "react-router-dom";

function NotFound() {
    return (
        <div className="mt-20 flex items-center justify-center bg-gray-50 dark:bg-gray-950 px-4">
            <div className="text-center max-w-xl">

                <h1 className="text-8xl md:text-9xl font-extrabold bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-700 bg-clip-text text-transparent">
                    404
                </h1>

                <h2 className="mt-4 text-3xl font-bold text-gray-900 dark:text-white">
                    Page Not Found
                </h2>

                <p className="mt-3 text-gray-600 dark:text-gray-400 leading-relaxed">
                    The page you're looking for doesn't exist, may have been moved,
                    or the URL might be incorrect.
                </p>

                <div className="mt-8">
                    <Link
                        to="/"
                        className="
                            inline-flex items-center gap-2
                            px-6 py-3
                            rounded-xl
                            font-semibold
                            text-white
                            bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-700
                            hover:shadow-xl
                            hover:scale-105
                            transition-all duration-300
                        "
                    >
                        ← Back to Homepage
                    </Link>
                </div>

            </div>
        </div>
    );
}

export default NotFound;